<template>
    <client-page>
        <sub-visual tit="문의하기" sc="마이스펙에 문의하세요(임시txt)" bg="/images/sub/visual/sv-question.jpg" />
        <section class="section">
            <v-container>
                <inquiry-input />
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import TermsComponent from "@/components/client/terms/terms-component.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import InquiryInput from "@/components/client/center/inquiry/inquiry-input.vue";;

export default {
    components: {
        SubVisual,
        ClientPage,
        TermsComponent,
        InquiryInput,
    },
};

</script>
